(function () {
  'use strict';

  var APP = 'KiftechCartShippingV6';
  var RESULT_SELECTOR = '.kt-cart-shipping-result';
  var LEGACY_SELECTOR = '.kt-cart-shipping-estimate';
  var TOTAL_SELECTOR = '#main-cart-footer .totals__total-value, #CartDrawer .totals__total-value';
  var DEFAULT_ADDRESS = {
    country: 'South Africa',
    province: 'Gauteng',
    zip: '2001',
    city: 'Johannesburg'
  };
  var state = {
    cart: null,
    rate: null,
    loading: false,
    error: '',
    requestId: 0
  };
  var timer;

  function boxes() {
    return document.querySelectorAll(RESULT_SELECTOR);
  }

  function removeLegacyCalculators() {
    document.querySelectorAll(LEGACY_SELECTOR).forEach(function (element) {
      element.remove();
    });
  }

  function route(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return (root.slice(-1) === '/' ? root : root + '/') + path.replace(/^\//, '');
  }

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function rateNames(rate) {
    return [
      rate && rate.presentment_name,
      rate && rate.name,
      rate && rate.service_name,
      rate && rate.code
    ].filter(Boolean).map(String);
  }

  function chooseRate(rates) {
    return Array.isArray(rates) && rates.length ? rates[0] : null;
  }

  function displayMethod(rate) {
    return rateNames(rate)[0] || 'Shipping';
  }

  function rateCents(rate) {
    var value = Number(String(rate && rate.price || 0).replace(',', '.'));
    return Number.isFinite(value) ? Math.max(0, Math.round(value * 100)) : 0;
  }

  function withDelimiters(cents, precision, thousands, decimal) {
    var value = Number(cents || 0) / 100;
    if (!Number.isFinite(value)) value = 0;

    var parts = value.toFixed(precision).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[0] + (parts[1] ? decimal + parts[1] : '');
  }

  function formatFromTemplate(cents, template, currency, withCurrency) {
    var safeTemplate = String(template || '').replace(/<[^>]*>/g, '');
    var match = safeTemplate.match(/\{\{\s*(\w+)\s*\}\}/);

    if (!match) {
      var fallback = (currency === 'ZAR' ? 'R ' : currency + ' ') + withDelimiters(cents, 2, ',', '.');
      return fallback + (withCurrency ? ' ' + currency : '');
    }

    var amount;
    switch (match[1]) {
      case 'amount_no_decimals':
        amount = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        amount = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        amount = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        amount = withDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        amount = withDelimiters(cents, 0, ' ', '.');
        break;
      case 'amount_with_space_separator':
        amount = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount':
      default:
        amount = withDelimiters(cents, 2, ',', '.');
        break;
    }

    return safeTemplate.replace(match[0], amount).trim();
  }

  function formatShippingMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: currency || 'ZAR',
        minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return (currency || 'ZAR') + ' ' + (cents / 100).toFixed(2);
    }
  }

  function updateEstimatedTotals() {
    if (!state.cart || !Number.isFinite(Number(state.cart.total_price))) return;

    var box = document.querySelector(RESULT_SELECTOR);
    var shipping = state.rate ? rateCents(state.rate) : 0;
    var estimatedTotal = Number(state.cart.total_price) + shipping;
    var currency = String(state.rate && state.rate.currency || state.cart.currency || 'ZAR').toUpperCase();
    var moneyFormat = box && box.dataset.moneyFormat || 'R {{amount}}';
    var moneyWithCurrencyFormat = box && box.dataset.moneyWithCurrencyFormat || 'R {{amount}} ZAR';

    document.querySelectorAll(TOTAL_SELECTOR).forEach(function (element) {
      if (!element.dataset.ktMoneyMode) {
        element.dataset.ktMoneyMode = new RegExp('\\b' + currency + '\\b', 'i').test(element.textContent || '')
          ? 'with-currency'
          : 'money';
      }

      var withCurrency = element.dataset.ktMoneyMode === 'with-currency';
      var template = withCurrency ? moneyWithCurrencyFormat : moneyFormat;
      setText(element, formatFromTemplate(estimatedTotal, template, currency, withCurrency));
      element.dataset.shippingIncluded = state.rate ? 'true' : 'false';
      element.dataset.shippingFeeCents = String(shipping);
    });
  }

  function shortDate(value) {
    if (!value) return '';
    var parsed = new Date(String(value).length === 10 ? value + 'T12:00:00' : value);
    if (Number.isNaN(parsed.getTime())) return String(value);
    return new Intl.DateTimeFormat('en-ZA', { day: 'numeric', month: 'short' }).format(parsed);
  }

  function transitText(rate, box) {
    if (Array.isArray(rate.delivery_days) && rate.delivery_days.length) {
      var minDays = Number(rate.delivery_days[0]);
      var maxDays = Number(rate.delivery_days[1] == null ? minDays : rate.delivery_days[1]);
      if (Number.isFinite(minDays) && Number.isFinite(maxDays)) {
        return 'Transit time: ' + (minDays === maxDays ? minDays : minDays + '–' + maxDays) + ' business days';
      }
    }

    if (Array.isArray(rate.delivery_range) && rate.delivery_range.length) {
      var firstRangeDate = shortDate(rate.delivery_range[0]);
      var lastRangeDate = shortDate(rate.delivery_range[1] || rate.delivery_range[0]);
      return 'Estimated delivery: ' + (firstRangeDate === lastRangeDate
        ? firstRangeDate
        : firstRangeDate + '–' + lastRangeDate);
    }

    if (rate.min_delivery_date || rate.max_delivery_date) {
      var firstDeliveryDate = shortDate(rate.min_delivery_date || rate.max_delivery_date);
      var lastDeliveryDate = shortDate(rate.max_delivery_date || rate.min_delivery_date);
      return 'Estimated delivery: ' + (firstDeliveryDate === lastDeliveryDate
        ? firstDeliveryDate
        : firstDeliveryDate + '–' + lastDeliveryDate);
    }

    if (rate.delivery_date) return 'Estimated delivery: ' + shortDate(rate.delivery_date);
    if (rate.estimated_time_in_transit) return 'Transit time: ' + rate.estimated_time_in_transit;

    var description = String(rate.description || '').trim();
    if (description && !/\b(processing|handling)\b/i.test(description)) {
      return /^transit(?:\s+time)?\s*:/i.test(description)
        ? description.replace(/^transit\s*:/i, 'Transit time:')
        : 'Transit time: ' + description;
    }

    var fallback = String(box && box.dataset.shippingTransitTime || '').trim();
    return fallback ? 'Transit time: ' + fallback : '';
  }

  function render() {
    removeLegacyCalculators();

    boxes().forEach(function (box) {
      var method = box.querySelector('.kt-cart-shipping-result__method');
      var price = box.querySelector('.kt-cart-shipping-result__price');
      var eta = box.querySelector('.kt-cart-shipping-result__eta');
      var status = box.querySelector('.kt-cart-shipping-result__status');

      box.dataset.shippingCalculatorVersion = 'v6';
      box.setAttribute('aria-busy', state.loading ? 'true' : 'false');

      if (status) {
        status.hidden = true;
        status.removeAttribute('data-error');
      }

      if (state.loading) {
        setText(method, 'Calculating shipping…');
        setText(price, '—');
        if (eta) eta.hidden = true;
      } else if (state.rate) {
        var shippingCents = rateCents(state.rate);
        var currency = state.rate.currency || state.cart && state.cart.currency || 'ZAR';
        var transit = transitText(state.rate, box);

        setText(method, displayMethod(state.rate));
        setText(price, shippingCents === 0 ? 'Free' : formatShippingMoney(shippingCents, currency));
        if (eta) {
          setText(eta, transit);
          eta.hidden = !transit;
        }
      } else {
        if (eta) eta.hidden = true;

        if (state.error) {
          setText(method, 'Shipping could not be calculated.');
          setText(price, '—');
          if (status) {
            setText(status, state.error);
            status.dataset.error = 'true';
            status.hidden = false;
          }
        } else if (state.cart && !state.cart.item_count) {
          setText(method, 'Add an item to calculate shipping.');
          setText(price, '—');
        } else if (state.cart && state.cart.requires_shipping === false) {
          setText(method, 'No shipping required');
          setText(price, 'Free');
        } else {
          setText(method, 'Calculating shipping…');
          setText(price, '—');
        }
      }
    });

    updateEstimatedTotals();
  }

  async function readJson(response, fallback) {
    var body = await response.text();

    if (!response.ok && response.status !== 202) {
      try {
        var payload = JSON.parse(body);
        throw new Error(payload.message || payload.description || payload.error || fallback);
      } catch (error) {
        if (error instanceof SyntaxError) throw new Error(body || fallback);
        throw error;
      }
    }

    return !body || body.trim() === 'null' ? null : JSON.parse(body);
  }

  function shippingAddressParams() {
    var params = new URLSearchParams();
    Object.keys(DEFAULT_ADDRESS).forEach(function (key) {
      params.set('shipping_address[' + key + ']', DEFAULT_ADDRESS[key]);
    });
    return params.toString();
  }

  async function fetchShippingRates() {
    var query = shippingAddressParams();
    var headers = {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Cache-Control': 'no-cache'
    };

    await readJson(await fetch(route('cart/prepare_shipping_rates.json') + '?' + query, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: headers
    }), 'Shipping rates could not be prepared.');

    for (var attempt = 0; attempt < 12; attempt += 1) {
      if (attempt) {
        await new Promise(function (resolve) {
          setTimeout(resolve, Math.min(300 + attempt * 120, 900));
        });
      }

      var data = await readJson(await fetch(route('cart/async_shipping_rates.json') + '?' + query, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: headers
      }), 'Shipping rates could not be returned.');

      if (data && Array.isArray(data.shipping_rates)) return data.shipping_rates;
    }

    throw new Error('Shipping rates are taking longer than expected. Please refresh the cart.');
  }

  async function fetchCart() {
    return readJson(await fetch(route('cart.js'), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache'
      }
    }), 'The cart could not be loaded.');
  }

  async function refresh() {
    var requestId = ++state.requestId;
    state.loading = true;
    state.rate = null;
    state.error = '';
    render();

    try {
      state.cart = await fetchCart();
      if (requestId !== state.requestId) return;
      render();

      if (!state.cart.item_count || state.cart.requires_shipping === false) {
        state.loading = false;
        render();
        return;
      }

      state.rate = chooseRate(await fetchShippingRates());
      if (requestId !== state.requestId) return;
      state.loading = false;
      if (!state.rate) state.error = 'No shipping method is available for this cart.';
    } catch (error) {
      if (requestId !== state.requestId) return;
      state.loading = false;
      state.rate = null;
      state.error = String(error && error.message || 'Shipping could not be calculated.')
        .replace(/<[^>]*>/g, '')
        .trim();
    }

    render();
  }

  function scan() {
    removeLegacyCalculators();
    render();
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(refresh, delay == null ? 350 : delay);
  }

  if (window[APP]) {
    window[APP].scan();
    return;
  }

  window[APP] = {
    scan: scan,
    refresh: function () { schedule(1); }
  };

  function start() {
    scan();
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('cart:updated', function () { schedule(150); });
  document.addEventListener('change', function (event) {
    if (event.target.matches('input[name="updates[]"], .quantity__input')) schedule(350);
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('quantity-input button, cart-remove-button, .cart-remove-button')) schedule(650);
  });

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      var shouldRefresh = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node && node.nodeType === 1 && (
            node.matches && (node.matches(RESULT_SELECTOR) || node.matches(LEGACY_SELECTOR) || node.matches('.totals__total-value')) ||
            node.querySelector && (node.querySelector(RESULT_SELECTOR) || node.querySelector(LEGACY_SELECTOR) || node.querySelector('.totals__total-value'))
          );
        });
      });

      if (shouldRefresh) {
        scan();
        schedule(80);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
